import { render } from "./EmailMange.vue?vue&type=template&id=0eb4d16b&scoped=true"
import script from "./EmailMange.vue?vue&type=script&lang=js"
export * from "./EmailMange.vue?vue&type=script&lang=js"

import "./EmailMange.vue?vue&type=style&index=0&id=0eb4d16b&lang=scss&scoped=true"
import "./EmailMange.vue?vue&type=style&index=1&id=0eb4d16b&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb4d16b"]])

export default __exports__